import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
    breakpoint: {
        thresholds: {
            xs: 320,
            sm: 480,
            md: 860,
            lg: 1024
        }
    }
}

export default new Vuetify(opts)
